import { getFootNoteOnSpecialGift, InHomeUtils, populateFootNotes } from "../../../util/inhomeUtils";
import { Service } from "../../../constants/actionType";
import { midniteProds } from "../cms/products";
// import {perksProducts} from '../cms/perks';
import {perksProducts} from '../cms/perksAEM'
import ReactHtmlParser from "react-html-parser";

export const getCmsData = (buildProduct={},flowType={}) => {
    const WIFI7 = window.sessionStorage.getItem('isWIFI7');
    const cmsProds = midniteProds?.Products || [];
      // Swat 186 - new price guarantee along with fee waiver changes
      if((buildProduct?.isMNEnabled || buildProduct?.mnFromApi) && !WIFI7){
        cmsProds?.filter(i => i?.identifier == "R3584" || i?.identifier == "R3585" || i?.identifier == "R3583"|| i?.identifier == "R3582"|| i?.identifier == "R3588"|| i?.identifier == "R3586"|| i?.identifier == "R3587")?.map(item => {
          if (item?.identifier == "R3584" && item?.cmsKeys) {
            if(buildProduct?.internet?.isFeeWaivedForAll){
            item.cmsKeys = 'productName: 500 Mbps^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when combined with postpaid mobile plan. Also get up to $10/mo towards and eligible perk, like Disney Bundle or Netflix & Max (With Ads), when you add and maintain a Fios 1Gig plan.^|^mnhTooltipdesc:  Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.", "Router Included", "5-year price lock guarantee"]^|^reviewDetails: ["500 Mbps", "Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            } else {
            item.cmsKeys = 'productName: 500 Mbps^|^banner: Order online to waive $99 professional setup charge^|^bannerTooltipTitle: $99 Setup charge waived^|^bannerTooltip: $99 setup charge waived for online orders installed by a technician.^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when combined with postpaid mobile plan. Also get up to $10/mo towards and eligible perk, like Disney Bundle or Netflix & Max (With Ads), when you add and maintain a Fios 1Gig plan.^|^mnhTooltipdesc:  Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.", "Router Included", "5-year price lock guarantee"]^|^reviewDetails: ["500 Mbps", "Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
          }
          }
          else if (item?.identifier == "R3585" && item?.cmsKeys) {
            item.cmsKeys = 'productName: 500 Mbps^|^mnhDiscount: 15^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. Mobile + Home Discount enrollment req\'d.^|^planDetails: ["Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.", "Router included","4-year price lock guarantee"]^|^reviewDetails: ["500 Mbps", "Up to 500 Mbps speeds|Download and upload speeds of up to 500 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "4-year price lock guarantee|Your monthly price for service is guaranteed not to change for 4 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            }       
          else if (item?.identifier == "R3583" && item?.cmsKeys) {
            if(buildProduct?.internet?.isFeeWaivedForAll){
                item.cmsKeys = 'productName: 1 Gig^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. 1 Gig or 2 Gig customers also get a $10/mo credit on any eligible perk. Mobile + Home Discount enrollment req\'d.^|^mnhTooltipdesc: Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 940 Mbps speeds|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.", "Router and Whole-Home Wi-Fi included", "5-year price lock guarantee"]^|^reviewDetails: ["1 Gig", "Up to 940 Mbps speed|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.|Availability varies. Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router and Whole-Home Wi-Fi included at no additional cost|<p>Verizon Router &#x2014; Fast, reliable Wi-Fi coverage with next-generation Tri-Band Wi-Fi 6E technology that supports Gigabit+ speeds, built-in security, parental controls and more. Automatically connects your device to the fastest and least crowded network band - ideal for households with many connected devices.</p><p>Whole-Home Wi-Fi &#x2014; Enjoy an enhanced Wi-Fi experience with 1 Verizon Wi-Fi Extender included with your plan, providing reliable coverage where you need it most.</p><p>During professional setup, the technician will test to determine if a Wi-Fi Extender is recommended and setup if needed. If you&#x27;re setting up Fios service yourself, 30 days after your service is activated, our Wi-Fi Health Check tool will automatically monitor the strength of the Wi-Fi connection between your router and connected devices, and indicate if an extender is recommended. If our analysis discovers signal issues, we will notify you via email to confirm shipment of a Verizon Wi-Fi Extender.</p><p>If you wish to test your own Wi-Fi network performance, you can do so at any time via the My Verizon app or contacting Verizon customer support.</p>|Additional Extenders are available to rent or purchase. Verizon owns the equipment provided with your plan, including the Verizon Router and Wi-Fi Extender. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]^|^upsellDetails: ["1 Gig", "Up to 940/880 Mbps <b>(Up to 440 more Mbps)</b>|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.|Availability varies. Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|download", "Router w/ Whole-Home Wi-Fi included <b>(No additional cost)</b>|<p>Includes a Wi-Fi Access Point (that functions as a router) and an additional Wi-Fi Access Point (that functions as an extender) if needed.<br><br>Even the best access points need some help extending their range sometimes. Your Wi-Fi Access Point will enable you to connect multiple devices at once with increased coverage, improved speed, power efficiency and enhanced security, but obstacles such as concrete walls and household appliances (like microwaves) can weaken or even block your Wi-Fi signal. Your additional Wi-Fi Access Point can help solve this issue if it arises. In other words, Whole-Home Wi-Fi has got you covered.<br><br>When do I receive a Wi-Fi Access Point?<br>A Wi-Fi Access Point (that functions as an extender), is provided on an as needed basis, at no cost, to customers, who receive Whole-Home Wi-Fi included as part of their plan. We’ll run a Home Wi-Fi Health Check 30 days after setting up your Fios service and every 30 days thereafter to determine if an additional Wi-Fi Access Point is needed.<br><br>If our analysis shows any opportunities for performance improvement, we will notify and send the customer an additional Wi-Fi Access Point at no cost. If the customer is experiencing Wi-Fi dead spotbs, they can request an additional Wi-Fi Access Point (via Verizon Home app or by contacting our customer support team) regardless of the results of our analysis.<br><br>Customers who purchase Whole-Home Wi-Fi as an add-on service to their plan, will be sent an additional Wi-Fi Access Point at no cost at the time of purchase, regardless of current Home Wi-Fi Health Check results. However, Home Wi-Fi Health Check will remain available to customers via the Verizon Home app, My Verizon Online, through our customer support team, or by a Verizon Fios Technician if they’re in customer’s premise.</p>||home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 4 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed",  "$99 setup fee waived when you order online |setup fee|setup fee|no-fee"]'
            } else {
                item.cmsKeys = 'productName: 1 Gig^|^banner: Order online to waive $99 professional setup charge^|^bannerTooltipTitle: $99 Setup charge waived^|^bannerTooltip: $99 setup charge waived for online orders installed by a technician.^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. 1 Gig or 2 Gig customers also get a $10/mo credit on any eligible perk. Mobile + Home Discount enrollment req\'d.^|^mnhTooltipdesc: Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 940 Mbps speeds|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.", "Router and Whole-Home Wi-Fi included", "5-year price lock guarantee"]^|^reviewDetails: ["1 Gig", "Up to 940 Mbps speed|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.|Availability varies. Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router and Whole-Home Wi-Fi included at no additional cost|<p>Verizon Router &#x2014; Fast, reliable Wi-Fi coverage with next-generation Tri-Band Wi-Fi 6E technology that supports Gigabit+ speeds, built-in security, parental controls and more. Automatically connects your device to the fastest and least crowded network band - ideal for households with many connected devices.</p><p>Whole-Home Wi-Fi &#x2014; Enjoy an enhanced Wi-Fi experience with 1 Verizon Wi-Fi Extender included with your plan, providing reliable coverage where you need it most.</p><p>During professional setup, the technician will test to determine if a Wi-Fi Extender is recommended and setup if needed. If you&#x27;re setting up Fios service yourself, 30 days after your service is activated, our Wi-Fi Health Check tool will automatically monitor the strength of the Wi-Fi connection between your router and connected devices, and indicate if an extender is recommended. If our analysis discovers signal issues, we will notify you via email to confirm shipment of a Verizon Wi-Fi Extender.</p><p>If you wish to test your own Wi-Fi network performance, you can do so at any time via the My Verizon app or contacting Verizon customer support.</p>|Additional Extenders are available to rent or purchase. Verizon owns the equipment provided with your plan, including the Verizon Router and Wi-Fi Extender. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]^|^upsellDetails: ["1 Gig", "Up to 940/880 Mbps <b>(Up to 440 more Mbps)</b>|Average wired speeds of 750 - 940 Mbps download and 750 - 880 Mbps upload.|Availability varies. Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|download", "Router w/ Whole-Home Wi-Fi included <b>(No additional cost)</b>|<p>Includes a Wi-Fi Access Point (that functions as a router) and an additional Wi-Fi Access Point (that functions as an extender) if needed.<br><br>Even the best access points need some help extending their range sometimes. Your Wi-Fi Access Point will enable you to connect multiple devices at once with increased coverage, improved speed, power efficiency and enhanced security, but obstacles such as concrete walls and household appliances (like microwaves) can weaken or even block your Wi-Fi signal. Your additional Wi-Fi Access Point can help solve this issue if it arises. In other words, Whole-Home Wi-Fi has got you covered.<br><br>When do I receive a Wi-Fi Access Point?<br>A Wi-Fi Access Point (that functions as an extender), is provided on an as needed basis, at no cost, to customers, who receive Whole-Home Wi-Fi included as part of their plan. We’ll run a Home Wi-Fi Health Check 30 days after setting up your Fios service and every 30 days thereafter to determine if an additional Wi-Fi Access Point is needed.<br><br>If our analysis shows any opportunities for performance improvement, we will notify and send the customer an additional Wi-Fi Access Point at no cost. If the customer is experiencing Wi-Fi dead spotbs, they can request an additional Wi-Fi Access Point (via Verizon Home app or by contacting our customer support team) regardless of the results of our analysis.<br><br>Customers who purchase Whole-Home Wi-Fi as an add-on service to their plan, will be sent an additional Wi-Fi Access Point at no cost at the time of purchase, regardless of current Home Wi-Fi Health Check results. However, Home Wi-Fi Health Check will remain available to customers via the Verizon Home app, My Verizon Online, through our customer support team, or by a Verizon Fios Technician if they’re in customer’s premise.</p>||home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 4 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed",  "$99 setup fee waived when you order online |setup fee|setup fee|no-fee"]'
            }
            }
            else if (item?.identifier == "R3582" && item?.cmsKeys) {
              if(buildProduct?.internet?.isFeeWaivedForAll){
              item.cmsKeys = 'productName: 2 Gig^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. 1 Gig or 2 Gig customers also get a $10/mo credit on any eligible perk. Mobile + Home Discount enrollment req\'d.^|^mnhTooltipdesc: Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 2.3 Gbps speeds|Download and upload average wired speeds of 1.5 Gbps - 2.3 Gbps.", "Router and Whole Home Wi-Fi included", "5-year price lock guarantee"]^|^reviewDetails: ["2 Gig", "Up to 2.3 Gbps speeds|Download and upload average wired speeds of 1.5 Gbps - 2.3 Gbps.|Availability varies. 2 Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router and Whole-Home Wi-Fi included at no additional cost|<p>Verizon Router &#x2014; Fast, reliable Wi-Fi coverage with next-generation Tri-Band Wi-Fi 6E technology that supports Gigabit+ speeds, built-in security, parental controls and more. Automatically connects your device to the fastest and least crowded network band - ideal for households with many connected devices.</p><p>Whole-Home Wi-Fi &#x2014; Enjoy an enhanced Wi-Fi experience with 1 Verizon Wi-Fi Extender included with your plan, providing reliable coverage where you need it most.</p><p>During professional setup, the technician will test to determine if a Wi-Fi Extender is recommended and setup if needed. If you&#x27;re setting up Fios service yourself, 30 days after your service is activated, our Wi-Fi Health Check tool will automatically monitor the strength of the Wi-Fi connection between your router and connected devices, and indicate if an extender is recommended. If our analysis discovers signal issues, we will notify you via email to confirm shipment of a Verizon Wi-Fi Extender.</p><p>If you wish to test your own Wi-Fi network performance, you can do so at any time via the My Verizon app or contacting Verizon customer support.</p>|Additional Extenders are available to rent or purchase. Verizon owns the equipment provided with your plan, including the Verizon Router and Wi-Fi Extender. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            } else {
              item.cmsKeys = 'productName: 2 Gig^|^banner: Order online to waive $99 professional setup charge^|^bannerTooltipTitle: $99 Setup charge waived^|^bannerTooltip: $99 setup charge waived for online orders installed by a technician.^|^mnhDiscount: 25^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. 1 Gig or 2 Gig customers also get a $10/mo credit on any eligible perk. Mobile + Home Discount enrollment req\'d.^|^mnhTooltipdesc: Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 Perk Credit per account, credit will be applied in 1-2 billing cycles.^|^planDetails: ["Up to 2.3 Gbps speeds|Download and upload average wired speeds of 1.5 Gbps - 2.3 Gbps.", "Router and Whole Home Wi-Fi included", "5-year price lock guarantee"]^|^reviewDetails: ["2 Gig", "Up to 2.3 Gbps speeds|Download and upload average wired speeds of 1.5 Gbps - 2.3 Gbps.|Availability varies. 2 Gigabit network connection to your home. Wired and wireless speeds vary due to device limits, multiple users, network & other factors. See verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router and Whole-Home Wi-Fi included at no additional cost|<p>Verizon Router &#x2014; Fast, reliable Wi-Fi coverage with next-generation Tri-Band Wi-Fi 6E technology that supports Gigabit+ speeds, built-in security, parental controls and more. Automatically connects your device to the fastest and least crowded network band - ideal for households with many connected devices.</p><p>Whole-Home Wi-Fi &#x2014; Enjoy an enhanced Wi-Fi experience with 1 Verizon Wi-Fi Extender included with your plan, providing reliable coverage where you need it most.</p><p>During professional setup, the technician will test to determine if a Wi-Fi Extender is recommended and setup if needed. If you&#x27;re setting up Fios service yourself, 30 days after your service is activated, our Wi-Fi Health Check tool will automatically monitor the strength of the Wi-Fi connection between your router and connected devices, and indicate if an extender is recommended. If our analysis discovers signal issues, we will notify you via email to confirm shipment of a Verizon Wi-Fi Extender.</p><p>If you wish to test your own Wi-Fi network performance, you can do so at any time via the My Verizon app or contacting Verizon customer support.</p>|Additional Extenders are available to rent or purchase. Verizon owns the equipment provided with your plan, including the Verizon Router and Wi-Fi Extender. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "5-year price lock guarantee|Your monthly price for service is guaranteed not to change for 5 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            }
          }
            else if (item?.identifier == "R3588" && item?.cmsKeys) {
              item.cmsKeys = 'productName: 100 Mbps^|^mnhDiscount: 15^|^mnhTooltip: Save $15/mo for existing Verizon postpaid mobile customers who add and maintain a Fios 100 Mbps plan. Mobile + Home Discount enrollment req\'d.^|^planDetails: ["Up to 100 Mbps speeds|Download and upload speeds of up to 100 Mbps.", "Router included", "3-year price lock guarantee"]^|^reviewDetails: ["100 Mbps", "Up to 100 Mbps speeds|Download and upload speeds of up to 100 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other facts. See Verizon.comyourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you’ll incur charges.|home-internet", "3-year price lock guarantee|Your monthly price for service is guaranteed not to change for 3 years. No surprises.|For new Verizon Home Internet(VHI) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            }
            else if (item?.identifier == "R3586" && item?.cmsKeys) {
              item.cmsKeys = 'productName: 300 Mbps^|^mnhDiscount: 15^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. Mobile + Home Discount enrollment req\'d.^|^planDetails: ["Up to 300 Mbps speeds|Download and upload speeds of up to 300 Mbps.", "Router included", "4-year price lock guarantee"]^|^reviewDetails: ["300 Mbps", "Up to 300 Mbps speeds|Download and upload speeds of up to 300 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com/yourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you\'ll incur charges.|home-internet", "4-year price lock guarantee|Your monthly price for service is guaranteed not to change for 4 years. No surprises.|For new Verizon Home Internet (“VHI”) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            } 
            else if (item?.identifier == "R3587" && item?.cmsKeys) {
              item.cmsKeys = 'productName: 300 Mbps^|^mnhDiscount: 15^|^mnhTooltip: Save $15/mo when on any postpaid mobile plan. Mobile + Home Discount enrollment req\'d.^|^planDetails: ["Up to 300 Mbps speeds|Download and upload speeds of up to 300 Mbps.", "Router included","3-year price lock guarantee"]^|^reviewDetails: ["300 Mbps", "Up to 300 Mbps speeds|Download and upload speeds of up to 300 Mbps.|Availability varies. Wired speeds advertised. Wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com&#x2F;yourspeed for more info.|speed-monitoring", "Router included at no additional cost|State-of-the art router featuring the latest Wi-Fi generation, Wi-Fi 6E, that provides more spectrum for increased speeds, better coverage, lower latency, built-in security, parental controls and more.|Verizon owns the router included with your plan. If you choose to disconnect service, you must return equipment within 30 days, or you&#x27;ll incur charges.|home-internet", "3-year price lock guarantee|Your monthly price for service is guaranteed not to change for 3 years. No surprises.|For new Verizon Home Internet (&#x22;VHI&#x22;) households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts, plan perk and any other third-party services.|lock-closed"]'
            }
        })   
      }
    const formattedProds = cmsProds?.filter(product => product?.cmsKeys)?.map(prod => {
        const isoc = {};
     
        const keys = prod?.cmsKeys?.split('^|^')?.map(key => {
            const props = key?.split(':');
            const pr = {};
            if(props?.[1]?.includes('[') && props?.[1]?.includes(']')) {
                props[1] = props?.[1]?.replace(/\\/g, '')?.trim();
                const parsedVal = props?.[1] &&  JSON.parse(props?.[1]);
                if(props?.[0] === 'reviewDetails' || props?.[0] === 'classicDetails' || props?.[0] === 'ecReviewDetails' || props?.[0] === 'upsellDetails') {
                    const listKeys = ['title', 'subtitle', 'helperText', 'icon'];
                    const reviewTemp = [];
                    parsedVal?.forEach((val, index) => {
                        const temp = {};
                            if(index === 0) {
                                temp['mainTitle'] = val;
                            } else {
                                const obj = parsedVal?.[index]?.split('|');
                                obj.forEach((k, index) => {
                                    temp[listKeys[index]] = k;
                                });
                            }
                            reviewTemp.push(temp);
                        });
                    pr[props[0]] = reviewTemp;
                } else {
                    pr[props[0]] = parsedVal;
                }
                
            } else {
                pr[props[0]] = typeof props?.[1] === 'string' ? props?.[1]?.trim()?.replace(/\\/g, '') : props?.[1];
            }            
            return pr;
        });
        isoc[prod["identifier"]] = Object.assign({}, ...keys);
        return isoc;
    });
    return Object.assign({}, ...formattedProds);
};

export function filterSpecialOffers(specialOffers, buildProduct, isString) {
  if (!Array.isArray(specialOffers)) {
    return specialOffers;
  } else {
    const DAW_DATA_5 = ["H4711", "O6327", "Q7736", "R1345", "R1346"];
    const DAW_DATA_10 = ["R1347"];
    const DAW_TV_10 = ["H6610"];
    const DAW_FDV_5 = ["Q7740"];
    const MNH_DATA = ["R3725", "R3726", "R3727", "R3728", "R3729"];
    const TWS_TEACHERS = ["Q9944", "Q9945", "Q9946"]; // Q9944 - $5, Q9945 - $10, Q9946 - $15
    const TWS_STUDENTS = ["R1986", "R1987", "R1988"]; // R1986 - $5, R1987 - $10, R1988 - $5
    const TWS_FIOS_DISCOUNT = ["P0256"];
    const SETUPFEE_WAIVER = ["R4341","R4342","R4446"];
    const $10_AutoPay =["R4340"];
    const TWS_NURSE_MEDICAL = ["Q9951", "Q9952", "Q9953"]; // Q9951 - $5, Q9952 - $10, Q9953 - $15
    const TWS_RESPONDER = ["Q9941", "Q9942", "Q9943"]; // Q9941 - $5, Q9942 - $10, Q9943 - $15
    const TWS_MILITARY = ["Q9938", "Q9939", "Q9940"]; // Q9938 - $5, Q9939 - $10, Q9940 - $15
    const SAVE_THE_SALE = ["R3883"];
    const VZ_FWD = ["R3484", "R3668", "R3669", "R3601", "R4437", "R4071", "R4072","R4136"];
    const MISC_REMOVE_LIST = ["P0255", "P0254", "P0257", "Q9947", "R3881", "R3984","R4018","R3884","R3885","R3927"];
    const PERK_PROMO_OFFERS = ['R4050', 'Q7734', 'Q7735']; // Q7734 - Autopay cmg in api response part of netmax changes.. Hence filtering that as well here
    const VIX_PROMO =  isString ? ["R3843"] : [];
    const ONE_MONTH = isString ? ["R4068"] : [];
    const NET_MAX_MARKER = ["R4048", "R4143", "R4262"];
    const XBOX_50 = ["R4141"];
    const MNH_PERK_CREDIT = ["R4259","R4258","R4257","R4256","R4255","R4254","R4253","R4252","R4251","R4250","R4249","R4440"];
    const EMPLOYE_DISC_OFFERS = ["R4225","R3732","R3682","R3563","R3564","R3566","R3567","R3568","R3569","R3570","Q9813","R4439"]
    const YOUTUBE_PREMIUM_MARKER = ["R4541"];
    const filteredSpecialOffers = specialOffers.filter(o => (
      !DAW_DATA_5.includes(o?.id) && !DAW_DATA_10.includes(o?.id) && !DAW_TV_10.includes(o?.id) && !DAW_FDV_5.includes(o?.id)
      && !MNH_DATA.includes(o?.id)
      && !TWS_TEACHERS.includes(o?.id) && !TWS_STUDENTS.includes(o?.id) && !TWS_FIOS_DISCOUNT.includes(o?.id) && !TWS_NURSE_MEDICAL.includes(o?.id) && !TWS_RESPONDER.includes(o?.id) && !TWS_MILITARY.includes(o?.id)
      && !SAVE_THE_SALE.includes(o?.id)
      && !VZ_FWD.includes(o?.id)
      && !MISC_REMOVE_LIST.includes(o?.id)
      && !PERK_PROMO_OFFERS?.includes(o?.id)
      && !VIX_PROMO.includes(o?.id)
      && !ONE_MONTH.includes(o?.id)
      && !NET_MAX_MARKER.includes(o?.id)
      && !XBOX_50.includes(o?.id)
      && !MNH_PERK_CREDIT.includes(o?.id)
      && !SETUPFEE_WAIVER?.includes(o?.id)
      && !$10_AutoPay?.includes(o?.id)
      && !EMPLOYE_DISC_OFFERS?.includes(o?.id)
      && (o?.BsOfferAttrValue !== "MF4MRKF15" && o?.BsOfferAttrValue !== "MF4DISCF15") // Mobile + Home Fios Discount
      && !YOUTUBE_PREMIUM_MARKER.includes(o?.id)
    ));
    return filteredSpecialOffers;
  }
}

const getEquipPromo = (plan, plansPromo, isClassicFlow, serviceType) => {
    const equipPromo = [];
    if(isClassicFlow && (serviceType === Service.internet || serviceType === Service.tv)) {
        equipPromo.push(ReactHtmlParser('<ul><li>' + plan.description + '</li></ul>'));
    } else {
        plan?.equipmentOffers?.forEach(offerId => {
            if (offerId.indexOf(":") > -1) {
                let promoApplicable = offerId.split(":")[0];

        if (promoApplicable.toUpperCase().indexOf(Service.data) > -1) {
                let promoOffer = offerId.split("|")[0];
                if (InHomeUtils.isNotNull(plansPromo[promoOffer]) && InHomeUtils.isNotNull(plansPromo[promoOffer]?.promo)) {          
                    if(plansPromo[promoOffer].promo.toLowerCase().includes('price')) {
                        equipPromo.push(plansPromo[promoOffer].promo);
                    }
                }  
                }
            }
        });
    }
    return equipPromo;
 };

const getSpecialOffers = plan => {
    /* ITT-687342: As per Kim Alvar's confirmation, Fios Setup Discount is considered Discount offer and not Special offer. Only Special offers will be displayed under this section. 
    */
    const validOffers = ['HomePod', 'Verizon Gift', 'Amazon Echo Show', '$200 Amazon.com Gift', '$100 Amazon.com Gift', '$50 Amazon.com Gift', 'Samsung', 'Target', 'Bonus', 'Teachers Fios Home'];
    return plan?.specialOffers?.filter(off => off?.offerFor == 'Data' && validOffers?.find(item => off?.OfferText.includes(item)));
};


const getSpecialOfferFromApi = (product,buildProduct,appState, lqState) => {
  try {
    const promoArr = specialChoiceOfferFromApiFormat(product, buildProduct, appState);
    if (Array.isArray(promoArr) && promoArr?.length === 2 && promoArr?.every?.(arr => Array.isArray(arr))) {
      let finalOfferTxt = "";
      let choiceOfferTxt = "";
      let includedOfferTxt = "";
      let hasMore = false;
      promoArr?.forEach?.((arr, index) => {
        const Amazon200GC = arr?.findIndex((item)=> ["R4564"].includes(item?.USOCIOSC)) > -1 ? true :false;
        const Amazon50GC = arr?.findIndex((item)=> ["R4566"].includes(item?.USOCIOSC)) > -1 ? true :false;
        let specialOffersArr = filterSpecialOffers(sortSpecialOffers(arr), buildProduct, true)?.map?.(o => {
          if (typeof o?.OfferText === "string") {
            return o?.OfferText;
          } else {
            return "";
          }
        })?.filter?.(o => o);
        if (Array.isArray(specialOffersArr) && specialOffersArr?.length > 0 && specialOffersArr?.every?.(o => typeof o === "string")) {
          let slicedSpecialOffersArr = [...specialOffersArr];
          if (slicedSpecialOffersArr?.length > 2) {
            hasMore = true;
          }
          slicedSpecialOffersArr = slicedSpecialOffersArr?.filter?.(o => {
            return !o?.toLowerCase?.()?.includes?.("gift card");
          });
          if (hasMore && slicedSpecialOffersArr?.length > 2) {
            slicedSpecialOffersArr = slicedSpecialOffersArr?.slice?.(0, 2);
          }
          if(lqState?.runtimeKey?.enablePromoFooterNotes === "Y"){
            const footNotes = populateFootNotes(buildProduct?.internet?.m2mPlans)
            slicedSpecialOffersArr= slicedSpecialOffersArr?.map(offer=>getFootNoteOnSpecialGift(offer, footNotes, lqState, appState?.flowType, true))
          }
          if (index === 0) {
            choiceOfferTxt = slicedSpecialOffersArr?.join?.(" or ");
          } else { 
            includedOfferTxt = slicedSpecialOffersArr?.join?.(" and ");
            //Swat 211 changes to show "and a Bonus" text for amazon gift cards
            if( !hasMore && Amazon200GC && Amazon50GC){
              includedOfferTxt += (slicedSpecialOffersArr?.length === 0 ? " a Bonus " : " and a Bonus ");
              includedOfferTxt += specialOffersArr?.filter?.(o => {
                return o?.toLowerCase?.()?.includes?.("gift card");
              })?.join?.(" and a Bonus ");
            }
          }
        }
      });
      if (choiceOfferTxt !== "" || includedOfferTxt !== "") {
        finalOfferTxt = (
          "Get "
          + (choiceOfferTxt || includedOfferTxt)
          + (hasMore ? ", and more." : "")
        );
        return finalOfferTxt;
      }
    }
  } catch (e) {
    console.error(e);
  }
  //Special offer handled from code if Plans call not sending
  console.log('***** product spl offer ', product);
  let isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex((item) =>["R3582", "R3583","R3584"].includes(item?.id)) > -1? false: true;
  let isgigPlan = product?.name?.toLowerCase()?.includes("gig");
  let is500Plan = product?.name?.toLowerCase()?.includes("500");

  let isSupp = appState?.flowType == "SUPP" ? true : false;
  let specialOfferIds = ["R3725", "R3726", "R3727", "R3728", "R3729"];

  let isMnHsignupIndicator =
    buildProduct?.internet?.mnhSignupIndicator === "Y"
      ? "Auth"
      : buildProduct?.internet?.mnhSignupIndicator === "N"
      && "Denied"
     

  let isSpecialOfferShow =
    specialOfferIds?.filter((val1) =>
      product?.specialOffers?.some((val2) => val1 === val2?.id)
    )?.length > 0
      ? false
      : false; //removing the M&H in Special offers section

  let AuthspecialOfferText = isMax500plan //Special offer handled from code if Plans call not sending
    ? is500Plan
      ? "Mobile + Home Fios $25 Discount."
      : "Mobile + Home Fios $15 Discount."
    : isgigPlan
    ? "Mobile + Home Fios $25 Discount."
    : "Mobile + Home Fios $15 Discount.";

  let DeniedspecialOfferText = isMax500plan //Special offer handled from code if Plans call not sending
    ? is500Plan
      ? "Mobile + Home Fios $25 Discount Eligible."
      : "Mobile + Home Fios $15 Discount Eligible."
    : isgigPlan
    ? "Mobile + Home Fios $25 Discount Eligible."
    : "Mobile + Home Fios $15 Discount Eligible.";

  let promoText = "";
  // CETC-146304 and CECT-146303: As per Kim Alvar's confirmation, Removed the "Teachers Fios Home Internet Discount and Deals at Work" offers not displayed at special offer section
  let allSpcialOffersList = [];
    const splRemoveofferList =["R1345", "Q9938", "Q9939", "Q9941", "Q9942", "Q9943", "Q9951", "Q9947","R1986", "R1987", "P0255", "P0256", "P0254", "P0257","P0256", "Q9947", "Q9946", "Q9945", "Q9944", "Q9951", "Q9952", "Q9953", "R4050","Q4732"];
  allSpcialOffersList = product?.specialOffers?.filter(
    (offer) => offer?.id !== "R1346" &&  offer?.id !== "R1347" && !splRemoveofferList?.includes(offer?.id))

  if (
    allSpcialOffersList?.filter((off) => off?.offerFor == "Data") &&
    InHomeUtils.isNotNull(allSpcialOffersList) &&
    allSpcialOffersList?.length > 0
  ) {
    // const saveTheSaleOffersRestrictDisplay = ["R3883", "R3884", "R3885"];
    // const restrictVzFwdOffers = ["R3484", "R3668", "R3669", "R3601"];
    // allSpcialOffersList = allSpcialOffersList?.filter(
    //   (item) => item?.id !== "P0256" && item?.id !== "R3881" && item?.id !=="R3984" && item?.id !=="R4018"
    // );
    // const filteredspecialOffers = allSpcialOffersList?.filter(
    //   (item) =>
    //     item?.id !== "R3927" &&
    //     item?.id !== "R3843" &&
    //     item?.id != "R3949" &&
    //     item?.id !== "R3982" &&
    //     item?.id!=="R3985"&&
    //     item?.id !=="R3986" &&
    //     item?.id!=="R3991"&&
    //     item?.id !=="R3992" &&
    //     !saveTheSaleOffersRestrictDisplay?.includes(item?.id) &&
    //     !restrictVzFwdOffers?.includes(item?.id)
    // );
    const is500MaxOrGig = ((isMax500plan && product?.name?.includes("500")) || (isgigPlan && product?.name?.includes("Gig")));
    let filteredspecialOffers = sortSpecialOffers(filterSpecialOffers(product?.specialOffers, buildProduct, is500MaxOrGig));
    let isFilteredSpecialOffersEmpty = false;
    if ((!Array.isArray(filteredspecialOffers) || (Array.isArray(filteredspecialOffers) && filteredspecialOffers?.length === 0))) {
      filteredspecialOffers = sortSpecialOffers(filterSpecialOffers(product?.specialOffers, buildProduct, false));
      isFilteredSpecialOffersEmpty = true;
    }
    //filtering for teasercopy text
   // filteredspecialOffers=filteredspecialOffers?.filter((item) =>item?.id!=="R4034"  &&item?.id!=="R4010"&& item?.id!=="R3949"&& item?.id!=="R3982" && item?.id!=="R3927")
    let promoTextArray = filteredspecialOffers?.filter(i => !(
        //  i?.id === "R4010"|| 
         i?.id === "R4034"||
         //(i?.id === "R3843" && is500MaxOrGig && !isFilteredSpecialOffersEmpty) ||
         i?.id === "R3843"|| // https://onejira.verizon.com/browse/PRODDEF-36123 : FiosRegression_Desktop/MW_New Connect: Empty space for special gift offer tile in build products page
         i?.id === "R3949"||
         i?.id === "R3982"||
         i?.id === "R3558"||
         i?.id === "R3985"||
         i?.id === "R3986"||
         i?.id === "R3991"||
         i?.id === "R3992"||
         i?.id === "R4055"||
         i?.id === "R4068" ||
         i?.id === "R4048" ||
         i?.id === 'Q7734' ||
         i?.id === 'R4141' ||
         i?.id === 'R4143' ||
         i?.id === 'Q7735' ||
         i?.id === 'R2543' ||
         i?.id === 'R4201'  || 
         i?.id === 'R4189'  ||
         i?.id === 'R4339'  ||
         i?.id === 'Q4732'  ||
         i?.id === 'R4418'||
         i?.id ==='R4425'||
         i?.id === 'R4426' ||
         i?.id === 'R4446' ||
         i?.id === 'R4554'||
         i?.id === 'R4555'||
         i?.id === 'R4556' ||
         i?.id === 'R4560'
      ))
         if(promoTextArray?.length === 0){
            promoText = ' ';
         }
         if(promoTextArray?.length === 0 && filteredspecialOffers?.some?.(i => i?.id === 'R2543')) {
          promoTextArray = filteredspecialOffers?.filter?.(i => i?.id === 'R2543')
         }
         let starzspecial = buildProduct?.splPromoOffersList?.filter((spl)=>spl?.id=="R4339");
         if(starzspecial?.length > 0){
          const spcloffer = {
            R4261 : '1', //netmax
            R4339 : '2', // starz
            R4189 : '3' ,//amazon hd

          }
          buildProduct?.splPromoOffersList?.sort((a,b) => { return spcloffer[a?.id] - spcloffer[b?.id]; })}
        let special = promoTextArray?.filter((spl)=> spl?.id == "R4142");

        if(special?.length > 0){
          const spcloffer = {
            R4140 : '1', //xbox bundle
            R4142 : '2', // net max
            R4139 : '3' ,//xbox series s

          }
          promoTextArray.sort((a,b) => { return spcloffer[a?.id] - spcloffer[b?.id]; })


          // promoTextArray = promoTextArray.reverse();

          promoTextArray = promoTextArray?.filter(i => !(
            i?.id === 'R3843' ||
            i?.id === 'R4093'   // black friday xbox series s
           ))
        }
        console.log("TEMP ARRAY",promoTextArray);

        promoTextArray?.map((item, index) => {
          item?.OfferText?.replace('Get','');
         
            promoText =
            promoTextArray?.length === 1
                    ? `Get ${item?.OfferText?.replace('Get','')?.replace('Credit','trial')}`
                    : index === 0
                        ? `Get ${is500Plan ? item?.OfferText?.replace('Get','')?.replace('1 Gig','500 Mbps')?.replace('on Us','') : item?.OfferText?.replace('Get','')?.replace('on Us','')?.replace('Credit','trial')?.replace('Samsung TV on us','Samsung TV')}`
                        : index === promoTextArray?.length - 1 &&
                            !item?.OfferText?.toLowerCase()?.includes("on us")
                            ? `${promoText} ${item?.id === "R3734" ||
                                (promoText?.includes("Disney Bundle") && !(promoText?.includes("Disney Bundle - Empl Discount")) ? item?.id !== "R3735" : item?.id === "R3735") ||
                                item?.id === "R3802" ||
                                item?.id === "R3830" ||
                                item?.id === "R3872" ||
                                item?.id === "R4049" ||
                                item?.id === "R4010" || 
                                item?.id === 'R4047' ||
                                item?.id === 'R4093' || 
                                item?.id === 'R4140' ||
                                item?.id === 'R4142' ||
                                item?.id === 'R4420' ||
                                item?.id === 'R4421'
                                ? "or"
                               : isgigPlan?item?.id ==="R4017" ? "or" : (item?.id === "R4139" ? ",plus" : "") 
                               : item?.id === "R4139" ? ",plus" : ""
                              } ${(item?.id === "R4340" || item?.id === "Q4732") ? "" 
                                : item?.OfferText?.replace('Get','')?.replace('Credit','trial')?.replace('Samsung TV on us','Samsung TV')} ${', on us'}`
                            : `${promoText} ${item?.id === "R3734" ||
                                (promoText?.includes("Disney Bundle") && !(promoText?.includes("Disney Bundle - Empl Discount")) ? item?.id !== "R3735" : item?.id === "R3735") ||
                                item?.id === "R3802" ||
                                item?.id === "R3830" ||
                                item?.id === "R4049" ||
                                item?.id === "R4010" ||
                                item?.id === "R4047" ||
                                item?.id === 'R4093' ||
                                item?.id === 'R4140' ||
                                item?.id === 'R4142' ||
                                item?.id === 'R4420' ||
                                item?.id === 'R4421'
                                ? "or"
                                : isgigPlan?item?.id ==="R4017" ? "or" :( item?.id === "R4139" ? ",plus" : ""):item?.id === "R4139" ? ",plus" : ""
                            } ${(item?.id === "R4340" || item?.id === "Q4732") ? "" 
                              : 
                                item?.OfferText?.replace('Get','')?.replace('Credit','trial')?.replace('Samsung TV on us','Samsung TV')?.replace('- 128 GB',',')}`;
            console.log('##########################', promoText, item)
        });

        if(promoText?.includes('Xbox Series S')){
          promoText += ',';
        }
        
        if(promoText?.toLowerCase()?.includes('gaming bundle')) {
          promoText += ' on us';
        }
    // filteredspecialOffers?.map((item, index) => {
    //   promoText =
    //     filteredspecialOffers?.length === 1
    //       ? item?.id ==="R3843" ? ' ':`Get ${item?.OfferText}`
    //       : index === 0
    //       ? `Get ${item?.OfferText}`
    //       : index === filteredspecialOffers?.length - 1 &&
    //         !item?.OfferText?.toLowerCase()?.includes("on us")
    //       ? `${promoText} ${
    //           item?.id === "R3734" ||
    //         //   (promoText?.includes("Disney Bundle") ? item?.id !== "R3735" : item?.id === "R3735") ||
    //           item?.id === "R3802" ||
    //           item?.id === "R3830" ||
    //           item?.id === "R3872" ||
    //           item?.id === "R4017" 
              
    //             ? "or"
    //             : "and"
    //         } ${item?.OfferText} on us.`
    //       : `${promoText} ${
    //           item?.id === "R3734" ||
    //         //   (promoText?.includes("Disney Bundle") ? item?.id !== "R3735" : item?.id === "R3735") ||
    //           item?.id === "R3802" ||
    //           item?.id === "R3830" ||
    //           item?.id === "R3872"
    //                          ? "or"
    //             : "and"
    //         } ${item?.OfferText}`;
    //         console.log('##########################',promoText,item)
    // });
  }

  

  let promoTextWithMnh =
    promoText +
    (isMnHsignupIndicator == "Auth"
      ? AuthspecialOfferText
      : isMnHsignupIndicator == "Denied"
      ? DeniedspecialOfferText
      : "");

  let finalPromoText = isSpecialOfferShow ? promoTextWithMnh : promoText;  
  console.log(finalPromoText, "finalPromoText", "399")

  return finalPromoText;
};

const specialChoiceOfferFromApiFormat = (product,buildProduct,appState) => {
  // let filteExternal =  Object.fromEntries(product?.specialOffers?.filter((obj)=>obj.extendedAttributes).map((obj)=>obj?.extendedAttributes)[0].split(",").map(pair=>pair.split(":")))
  // console.log(filteExternal, "407")
  let allOffers = [] ;
  let choiceOffers = [];
  let includedOffers = []
  let allSpcialOffers = product?.specialOffers?.filter((obj)=>obj.extendedAttributes);
  allSpcialOffers.filter((spl)=>{
    if(spl?.extendedAttributes?.toUpperCase()?.includes("ISCHOICE:YES")){
      choiceOffers.push(spl)
    }else if (spl?.extendedAttributes?.toUpperCase()?.includes("TILEDISPLAY:YES")){
      includedOffers.push(spl)
    }
  })
  allOffers.push(choiceOffers)
  allOffers.push(includedOffers)
   return allOffers
    
}


const specialOfferFromApiFormat = (product,buildProduct,appState) => {

    let isMax500plan = buildProduct?.internet?.m2mPlans?.findIndex(item => ["R3582","R3583"].includes(item?.id))> -1 ? false : true;
    let isgigPlan = product?.name?.toLowerCase()?.includes("gig")
    let is500Plan = product?.name?.toLowerCase()?.includes("500")
    let isSupp = appState?.flowType == "SUPP" ? true : false;
    let specialOfferIds = ["R3725", "R3726", "R3727", "R3728", "R3729"];
    let isMnHsignupIndicator =
    buildProduct?.internet?.mnhSignupIndicator === "Y"
      ? "Auth"
      : buildProduct?.internet?.mnhSignupIndicator === "N"
      && "Denied"
     
    let isSpecialOfferShow =
      specialOfferIds?.filter((val1) =>
        product?.specialOffers?.some((val2) => val1 === val2?.id)
      )?.length > 0
        ? false
        : false; //removing the M&H in Special offers section

    let AuthspecialOfferText = isMax500plan                 //Special offer handled from code if Plans call not sending
      ? is500Plan
        ? [{OfferText:"Mobile + Home Fios $25 Discount"}]
        : [{OfferText:"Mobile + Home Fios $15 Discount"}]
      : isgigPlan
      ? [{OfferText:"Mobile + Home Fios $25 Discount"}]
      : [{OfferText:"Mobile + Home Fios $15 Discount"}];

    let DeniedspecialOfferText = isMax500plan                 //Special offer handled from code if Plans call not sending
    ? is500Plan
      ? [{OfferText:"Mobile + Home Fios $25 Discount Eligible"}]
      : [{OfferText:"Mobile + Home Fios $15 Discount Eligible"}]
    : isgigPlan
    ? [{OfferText:"Mobile + Home Fios $25 Discount Eligible"}]
    : [{OfferText:"Mobile + Home Fios $15 Discount Eligible"}];

  let specialOfferFromApi = [];
//   (props?.lqState?.runtimeKey?.isAllowXboxOffer === "Y"||true )&&
 // CETC-146304 and CECT-146303: As per Kim Alvar's confirmation, Removed the "Teachers Fios Home Internet Discount and Deals at Work" offers not displayed at special offer section 
let allSpcialOffers = [];
// const removeOffersSpl = ["Q9938", "Q9939", "Q9940", "Q9944", "Q9945", "Q9946", "Q9947", "P0256", "P0257", "Q9942", "Q9941", "Q9943", "P0255", "P0254", "R1987", "R1986", "R1987", "P0256", "Q9947", "Q9951", "Q9952", "Q9953" ]
// allSpcialOffers = product?.specialOffers?.filter(offer=>(offer?.id !== "R1346" && offer?.id !== "R1347" ))
allSpcialOffers = sortSpecialOffers(filterSpecialOffers(product?.specialOffers, buildProduct));
if(isgigPlan || isMax500plan){
specialOfferFromApi = allSpcialOffers &&
    allSpcialOffers
      ?.filter(
        (a) =>
          a.offerFor == "Data" &&
        //   ((!(props?.buildProduct?.internet?.isInstallFeeWaivedAllPrd ||false) &&
          ((!(false) &&
            a.OfferText?.indexOf("Setup Fee Waiver") > -1) ||
            a.OfferText?.indexOf("HomePod") > -1 ||
            a.OfferText?.indexOf("Amazon Echo Show") > -1 ||
            a.OfferText?.indexOf("$200 Amazon.com Gift") > -1 ||
            a.OfferText?.indexOf("$100 Amazon.com Gift") > -1 ||
            a.OfferText?.indexOf("$50 Amazon.com Gift") > -1 ||
            a.OfferText?.indexOf("Samsung Chromebook") > -1 ||
            // a.OfferText?.indexOf("Nintendo") > -1 ||
            a.OfferText?.indexOf("Teachers Fios Home") > -1 ||
            a.OfferText?.indexOf("NFL") > -1 ||
            a.OfferText?.indexOf("$20 Monthly Bill Incentive") > -1 ||
            a.OfferText?.indexOf("$10 bill credit for 24 months")>-1||
            a.OfferText?.indexOf("Disney Bundle Perk 12 Months On Us")>-1 ||
            a.OfferText?.indexOf("$400 Samsung") > -1 ||
            a.OfferText?.indexOf("Netflix & Max (With Ads) Perk for 12 months") > -1 ||
            a.OfferText?.indexOf("Netflix and Max (With Ads) 12 Months on Us") > -1 ||
            a.OfferText?.indexOf("Xbox Gaming Bundle") > -1 ||
            a.OfferText?.indexOf("Xbox Bundle - Headset and Controller") > -1 ||
            a?.OfferText?.indexOf("Xbox Series S") > -1 ||
            a.OfferText?.indexOf("JBL") > -1) &&
          a.OfferText?.indexOf("Bonus") == -1 ||
          a.OfferText?.indexOf("Auto-Pay and Paper Free Discount - Internet") > -1 ||
          a.OfferText?.indexOf("Samsung TV on us") > -1 ||
          a.OfferText?.indexOf("Meta Quest 3S headset") > -1 
      )
    }
    console.log("special offers22",specialOfferFromApi)
      let arr1 =[]
      let arr2 =[]
      let arr3 = []
      if (!buildProduct?.internet?.isLeadListAddress) {
        let sploffer = specialOfferFromApi?.filter(offer=>offer?.id !=="R3735" && offer?.id !=="R4009" && offer?.id!=="R4010" && offer?.id !=="R4011" && offer?.id !=="R4021" &&offer?.id !== "R4261") || [];
        specialOfferFromApi = [...sploffer]
      }
      let removeCyberMondayXbox = specialOfferFromApi?.filter(offer=>offer?.id !== "R4139") || [];
      specialOfferFromApi = [...removeCyberMondayXbox]
      arr1?.push(specialOfferFromApi)
      arr2 = allSpcialOffers?.filter((val1) =>!specialOfferFromApi?.some((val2) => val1?.OfferId === val2?.OfferId))
      arr3 = isSpecialOfferShow
        ? isMnHsignupIndicator == "Auth"
          ? [...arr2, ...AuthspecialOfferText]
          : isMnHsignupIndicator == "Denied"
          ? [...arr2, ...DeniedspecialOfferText]
          : [...arr2]
        : [...arr2];
      arr1?.push(arr3)
      return arr1
};

export const formatProduct = (product, plansPromo, isClassicFlow, serviceType,buildProduct,appState,flowType, lqState) => {
    const internetCmsProds = getCmsData(buildProduct,flowType);    
    const cmsProds = internetCmsProds?.[product?.id];        
    const planDtls = cmsProds && cmsProds?.planDetails ? cmsProds?.planDetails : [];    
    const equipPromoApi = product?.equipmentOffers ? getEquipPromo(product, plansPromo, isClassicFlow, serviceType) : [];
    
    let equipDetails;
    if(product?.prodType == 'FVPRIMARY' || product?.prodType === 'SPLOFFER') {
         equipDetails = [...planDtls];
    }else{
         equipDetails = [...planDtls, ...equipPromoApi];
    }

    if(product?.countryName && product?.usageCap) {
        equipDetails = [product.usageCap];
    }
    /*
        Add other props related for differnet products / product types.
    */
    return {
        // need to update the prod type here to filter the logic in mnTile
        type: 'internet',
        ...cmsProds,
        ...product,
        price: product?.displayPrice ? product?.displayPrice?.replace('\$', '').replace('/mo', '') : product?.originalPrice,
        equipPromo: equipDetails,        
        // ...(product?.equipmentOffers?.length > 0 && { equipPromo: equipDetails }),
        ...(product?.specialOffers && { extras: getSpecialOffers(product)}),
        ...(product?.specialOffers && {specialOffers: getSpecialOffers(product)}),
        ...(product?.specialOffers && {specialOffersfromApi: product?.specialOffers}),
        ...(product?.specialOffers && {splOferFrmApi: getSpecialOfferFromApi(product,buildProduct,appState,lqState)}), // promo text 
      //  ...(product?.specialOffers && {specialOffersfromApiArr: specialOfferFromApiFormat(product,buildProduct,appState)}), // hardcoded method commenting 
      ...(product?.specialOffers && {specialOffersfromApiArr: specialChoiceOfferFromApiFormat(product,buildProduct,appState)}),
    };
};

export const formatInternet = (buildProduct, plansPromo) => {

    // Fetching M2M plans alone as only it is used as of the latest reskin changes (/buildProduct/indexRskn.js)
    let router = buildProduct?.router?.equipments?.map((plan)=> {
       
        return {
            name: plan?.name,
            description: plan?.description,
            displayPrice: plan?.displayPrice.replace('\$', ''),
            originalPrice: plan?.originalPrice,
            accordionTitle: plan?.accordionTitle,
            id: plan?.id,
          
        }
    });

    let techSureProducts = buildProduct?.techsure?.techsureProducts?.map((techProd, index)=> {
        return {
            name: techProd?.name,
            description: techProd?.description,
            displayPrice: techProd?.displayPrice.replace('\$', ''),
            originalPrice: techProd?.originalPrice,
            accordionTitle: techProd?.accordionTitle,
            id: techProd?.id,
            bundleId: techProd?.bundleId,
            selectedProduct: buildProduct?.techsure?.selectedProduct
        }
    });
    
    const internetCmsProds = getCmsData();
    return buildProduct?.internet?.m2mPlans?.map((plan) => {
        const cmsProds = internetCmsProds[plan.bundleKey];        
        const planDtls = cmsProds && cmsProds?.planDetails ? cmsProds.planDetails : [];
        const equipDetails = [...planDtls, ...getEquipPromo(plan, plansPromo)];
        return {
            ...cmsProds,
            ...plan,
            // need to update the prod type here to filter the logic in mnTile
            type: 'internet',
            price: plan.displayPrice.replace('\$', ''),            
            ...(plan?.equipmentOffers?.length > 0 && { equipPromo: equipDetails }),
            ...(plan?.specialOffers && { extras: getSpecialOffers(plan)}),
            selectedProduct: buildProduct.internet.selectedProduct,
            router: router
        }
    });
};

const getTVCmsData = () => {
    const cmsProds = midniteProds?.Products || [];
    const formattedProds = cmsProds?.filter(product => product?.cmsKeys)?.map(prod => {
        const isoc = {};
     
        const keys = prod?.cmsKeys?.split('^|^')?.map(key => {
            const props = key?.split(':');
            const pr = {};
            if(props[1]?.includes('[') && props[1]?.includes(']')) {
                props[1] = props[1]?.replace(/\\/g, '');
                pr[props[0]] = JSON.parse(props[1]);
            } else {
                pr[props[0]] = typeof props[1] === 'string' ? props[1]?.trim()?.replace(/\\/g, '') : props[1];
            }            
            return pr;
        });

        isoc[prod["identifier"]] = Object.assign({}, ...keys);
        return isoc;
    });
    return Object.assign({}, ...formattedProds);
};
    
const getTVEquipPromo = (plan, plansPromo) => {
    const equipPromo = [];
    plan?.equipmentOffers?.forEach((offerId) => {
        if (offerId?.indexOf(":") > -1) {
        let promoApplicable = offerId?.split(":")?.[0];
        if (promoApplicable?.toUpperCase()?.indexOf(Service?.video) > -1) {
            let promoOffer = offerId?.split("|")?.[0];
            if (
            InHomeUtils?.isNotNull(plansPromo?.[promoOffer]) &&
            InHomeUtils?.isNotNull(plansPromo?.[promoOffer]?.promo)
            ) {
            equipPromo?.push(plansPromo?.[promoOffer]?.promo);
            }
        }
        }
    });
    return equipPromo;
};
      
const getTVSpecialOffers = (plan) => {
    const validOffers = ["$200 Verizon Gift Card", "$50 Verizon Gift Card"];
    let specialOffers= plan?.specialOffers?.filter(
        (off) =>
            off?.offerFor == "Video" &&
            validOffers?.find((item) => off?.OfferText?.includes(item))
        )?.map(item => {
        return {
            ...item,
            OfferText:item.OfferText?.replace("(TV)","")
        };
        })
    return specialOffers;
};
      
export const formatTVProduct = (product, plansPromo, isClassicFlow, appState) => {
    
    const TVCmsProds = getCmsData();
    const cmsTVProds = TVCmsProds?.[product.id];  
    const planDtls = cmsTVProds && cmsTVProds?.planDetails ? cmsTVProds.planDetails : [];  

    let description ="";
    if(InHomeUtils.isNotEmpty(product?.description) && InHomeUtils.isNotNull(product?.description) || isClassicFlow){
        description = product?.description;
    }else{
        description = cmsTVProds?.description?.[0] ? cmsTVProds?.description?.[0] : "";
    }

    // Work around as Storage coming different from api than expected in content doc wrt YT TV promo changes
    if(product?.id === 'R2584') {
        product['planFeature'] = '';
    }

    const reviewTVDetails = cmsTVProds && cmsTVProds?.reviewDetails ? cmsTVProds.reviewDetails : [];
    const TVequipPromoApi = (product.id != "R3575" && product?.id!="R4298" && product?.id!="R4299" && product?.id!="R4300"&& product?.id!="R4301"&& product?.id!="R4302"&& product?.id!="R4303"&& product?.id!="R4304"&& product.id != "R3573" &&  product.id != "R3572") ? (product?.equipmentOffers ? getTVEquipPromo(product, plansPromo) : []) : [];
    const equipDetails = [description, ...planDtls, ...TVequipPromoApi];
    const result = {
        type: "TV",
        ...cmsTVProds,
        ...product,
        price: product?.displayPrice ? product?.displayPrice?.replace('\$', '').replace('/mo.', '') : product?.Price,    
        equipPromo: formatTvEquipDetails(equipDetails, isClassicFlow),
        reviewTVDetails,
        ...(product?.specialOffers && { extras: getTVSpecialOffers(product) })
    };
    // Remove the Try unlimited streaming text from TVs other than Most, Mundo Total, and Local if flowType is EC
    if (
        product?.id !== "R3575" && product?.id !== "R3573" && product?.id !== "R3571"
        && appState?.flowType === "AF"
    ) {
        result.planDetails = Array.isArray(result?.planDetails) ? result?.planDetails?.filter(p => !p?.includes("Try unlimited streaming")) : [];
        result.equipPromo = Array.isArray(result?.equipPromo) ? result?.equipPromo?.filter(p => !p?.includes("Try unlimited streaming")) : [];
        result.reviewDetails = Array.isArray(result?.reviewDetails) ? result?.reviewDetails?.filter(p => !p?.title?.includes("Try unlimited streaming")) : [];
        result.reviewTVDetails = Array.isArray(result?.reviewTVDetails) ? result?.reviewTVDetails?.filter(p => !p?.title?.includes("Try unlimited streaming")) : [];
    }
    return result;
}

export const formatPerks = (product,buildProduct, lqState) => {
  
  const cmsPerks = buildProduct?.perksFragments ? Object.values(buildProduct?.perksFragments) : null;
  const cmsProds = perksProducts?.Products || [];
  let isFetchingPerkFromAEM = false;
  let isDataReturningFromAEM = false;
  try {
    cmsPerks?.forEach((val, index) => {
      if (val?.perks && val?.perks != '' && val?.perks != null && val?.perks != undefined) {
        if (Object.keys(val?.perks)?.length > 0 && Object.keys(val?.['perks-pricing'])?.length > 0) {
          isDataReturningFromAEM = true;
        }
      }
    })
  } catch (e) {
    console.error(e);
  }
  console.log(isDataReturningFromAEM,'isDataReturningFromAEM');
  if(cmsPerks != '' && cmsPerks !== null && cmsPerks !== undefined && cmsPerks?.length > 0 && lqState?.runtimeKey?.isPerkFetchingFromAEM === 'Y' && isDataReturningFromAEM === true){
    isFetchingPerkFromAEM = true;    // true - need to check above condition
  }
  let perkData = isFetchingPerkFromAEM ? cmsPerks : cmsProds
    let getSpocIdtoMapPerk = product?.productKeyword;
    let getSPOID;
    let getSPOIDIndex;
    let splitProductKeyword = getSpocIdtoMapPerk?.split("|");
      splitProductKeyword?.forEach((val, index) => {
        if (val?.indexOf("SPO") > -1) {
          getSPOIDIndex = index;
          let extractSPOID =
            splitProductKeyword?.[getSPOIDIndex]?.indexOf(":") + 1;
          getSPOID = splitProductKeyword?.[getSPOIDIndex]?.substring?.(extractSPOID);
        }
      });
   
    const perkDetails = [];
    let finalVal = {}; 
    // let isPerkMappingWithAEM = true;
    perkData?.forEach((val, index) => {
        if(val?.perks != '' && val?.perks != null  && val?.perks != undefined){
          if ((Object.keys(val?.perks)?.indexOf?.(getSPOID+'_FIOS') > -1 || Object.keys(val?.perks)?.indexOf?.(getSPOID) > -1 || Object.keys(val?.perks)?.indexOf?.(getSPOID+'_ALL') > -1) && !product?.group) {
            let isSPOIDMapped = false;
            if(Object.keys(val?.perks)?.indexOf?.(getSPOID) === -1){
              isSPOIDMapped = true;
            }
            finalVal = checkForGroupItems(val,getSPOID,product,isSPOIDMapped);
            finalVal['id'] = finalVal['productId']
            perkDetails.push(finalVal);
        }else if((Object.keys(val?.perks)?.indexOf?.(getSPOID+'_FIOS') > -1 || Object.keys(val?.perks)?.indexOf?.(getSPOID) > -1 || Object.keys(val?.perks)?.indexOf?.(getSPOID+'_ALL') > -1) && product?.group?.length > 0){
          let isSPOIDMapped = false;
            if(Object.keys(val?.perks)?.indexOf?.(getSPOID) === -1){
              isSPOIDMapped = true;
            }
            product?.group?.forEach?.((item, index) => {
              let getSpocIdtoMapPerkForGroup = item?.productKeyword;
              let splitProductKeywordForGroup = getSpocIdtoMapPerkForGroup?.split?.("|");
              let getSPOIDForGrp;
              let getSPOIDIndexForGroup;
              splitProductKeywordForGroup?.forEach?.((val, indexloop) => {
                if (val?.indexOf?.("SPO") > -1) {
                  getSPOIDIndexForGroup = indexloop;
                  let extractSPOIDForGrp =
                  splitProductKeywordForGroup?.[getSPOIDIndexForGroup]?.indexOf?.(":") + 1;
                  getSPOIDForGrp = splitProductKeywordForGroup?.[getSPOIDIndexForGroup]?.substring?.(extractSPOIDForGrp);
                }
              });
                if(index === 0){
                    finalVal = checkForGroupItems(val,getSPOIDForGrp,item,isSPOIDMapped);
                    finalVal['drawer'] = false;
                    finalVal['id'] = finalVal?.['productId'];
                    perkDetails.push(finalVal);
                }else{
                  let otherVal = checkForGroupItems(val,getSPOIDForGrp,item,isSPOIDMapped)
                  otherVal['id'] = otherVal?.['productId'];
                  perkDetails.push(otherVal)
                } 
            })
          }
        }       
      });
    // else {
    //   isPerkMappingWithAEM = false;
    //     cmsProds?.forEach((val, index) => {
    //       if ((Object.keys(val?.perks)?.indexOf(product?.productId) > -1 && !product?.group)) {
    //           finalVal = checkForGroupItems(val,'',product,'',isPerkMappingWithAEM);
    //           perkDetails.push(finalVal);
    //       }else if(Object.keys(val?.perks)?.indexOf(product?.productId) > -1 && product?.group?.length > 0){
    //           product?.group?.forEach((item, index) => {
    //               if(index === 0){
    //                   finalVal = checkForGroupItems(val,'',item,'',isPerkMappingWithAEM);
    //                   finalVal['drawer'] = false;
    //                   perkDetails.push(finalVal);
    //               }else{
    //                   perkDetails.push(checkForGroupItems(val,'',item,'',isPerkMappingWithAEM))
    //               } 
    //           })
    //       }
    //   });
    // }
  
    return {
        type: "perks",
        perkDetails,
        data:finalVal
    };
};

const checkForGroupItems = (val, getSPOID, product, isSPOIDMapped) => {
  let mappingIDForPerks = "";
  let mappingID = "";
  mappingID = getSPOID;
  if (isSPOIDMapped === true) {
    mappingIDForPerks = getSPOID + "_ALL";
  } else {
    mappingIDForPerks = getSPOID;
  }
  return {
    ...val?.["perks"]?.[mappingIDForPerks]?.data,
    ...val?.["perks-pricing"]?.[mappingID]?.data,
    ...product,
  };
};
// const checkForGroupItems = (val,getSPOID,product,isSPOIDMapped,isPerkMappingWithAEM) =>{

//   let mappingIDForPerks = '';
//   let mappingID = '';
//   if(isPerkMappingWithAEM){
//     mappingID =  getSPOID;

//     if(isSPOIDMapped === true){
//       mappingIDForPerks =  getSPOID+'_ALL';
//     } else {
//       mappingIDForPerks =  getSPOID;
//     }

//   } else {
//     mappingIDForPerks = product?.productId;
//     mappingID = product?.productId;
//   }
  
//     return {
//         ...val?.["perks"]?.[mappingIDForPerks]?.data,
//         ...val?.["perks-pricing"]?.[mappingID]?.data,
//         ...product,
//     };
// }  

const formatTvEquipDetails = (equipDetails, isClassicFlow) => {
    let result = [];
    if (Array.isArray(equipDetails)) {
        result = equipDetails.filter(item => item !== "");
        let setTopIndex = result.indexOf("1 Set-Top Box Included");
        if (setTopIndex !== -1 && equipDetails.includes("1 Set-Top Box rental included")) {
            result.splice(setTopIndex, 1);
        }
        let basicDvrIndex = result.indexOf("Basic DVR");
        if (basicDvrIndex !== -1) {
            result[basicDvrIndex] = "Basic DVR service";
        }


        let fiosTvIndex = result.indexOf("Try unlimited streaming on your own devices for 2 months, on us");
        if (fiosTvIndex !== -1 && equipDetails.includes("Try unlimited streaming on your own devices for 2 months, on us")) {
            result.splice(fiosTvIndex, 1);
        }

    }
    return result;
}

export function getYearGuaranteeText(servicehead) {
    if (!Array.isArray(servicehead)) {
        return "";
    }
    const cmsData = getCmsData();
    const cmsProd = servicehead?.map(prod => cmsData[prod?.prodId]).filter(Boolean)?.filter((ser)=> ser?.prodId != "").find(prod => ["2 GIG", "1 GIG", "500 MBPS", "500 MBPS", "300 MBPS", "100 MBPS"].includes(prod?.productName?.toUpperCase()));
    let year=false;
    year=cmsProd?.reviewDetails?.[3]?.title?.toString()?.includes("Year")
    switch(year) {
        /*Commenting - since 4 year should not be displayed in cart , now data is qualified for 5 years ITT-699323
          case "4-year price lock guarantee":
            return "4 Year Internet Price Guarantee";*/
        case "3-year price lock guarantee":
            return "3 Year Internet Price Guarantee";
        case "2-year price lock guarantee":
            return "2 Year Internet Price Guarantee";
        case "1-year price lock guarantee":
            return "1 Year Internet Price Guarantee";
        default:
            return "";
    }
}

export const getPerkActualPrice = perkId => {
    const perks = {
        R3559: 16.98, // Netflix & Max
        R3558: 21.99, // Disney Bundle
        R3556: 19.95, // Apple One
        R3554: 12.95, // Walmart
        R3555: 16.99, // Apple Music
        R3680: 13.99, // Youtube Premium
        R3551: 15.00, // +play
        R3552: 13.99, // Unlimited cloud storage
        R3553: 19.99, // Unlimited cloud group
        R3731: 15.00, // Verizon Home Advisor
        R3784: 38.00 // Verizon HOme Device Protect
    };
    return perks[perkId];
}

export function replaceSpecialOffers(offers, plan) {
  try {
    if (Array.isArray(offers)) {
      return offers.map(o => {
        if (o?.id === "R4049"  || o?.id === "R4140" && o?.OfferText !== "Xbox Gaming Bundle") {
          return { ...o, OfferText: "Xbox Gaming Bundle" };
        } else if (o?.id === "R4047" || o?.id === "R4142" && plan?.name) {
          return { ...o, OfferText: 'Netflix & Max (With Ads) Perk for 12 months' };
        } else if (o?.id === "R4093"  || o?.id === "R4139"  && o?.OfferText !== "Xbox Series S") {
          return { ...o, OfferText: "Xbox Series S" };
        } 
        else {
          return o;
        }
        
      });
      
    }
  } catch (e) {
    console.error(e);
  }
  return offers;
}

export function sortSpecialOffers(offers) {
  try {
    if (Array.isArray(offers)) {
      const sortedOffers = [...offers].sort((a, b) => Number(a?.Rank) - Number(b?.Rank));
      return sortedOffers;
    }
  } catch (e) {
    console.error(e);
  }
  return offers;
}

export function hasPerkGift(product, serviceType, buildProduct, profileCart, ecProfileCart) {
  const isEmberMnHAuthenticated = buildProduct?.internet?.mnhSignupIndicator === "Y" && buildProduct?.emberInfo?.isEmberFlow;
  const plans = Array.isArray(buildProduct?.internet?.m2mPlans) && buildProduct?.internet?.m2mPlans?.length > 0
    ? buildProduct?.internet?.m2mPlans
    : Array.isArray(buildProduct?.internet?.twoYearPlans) && buildProduct?.internet?.twoYearPlans?.length > 0
      ? buildProduct?.internet?.twoYearPlans
      : [];
  const isGigPlan = plans?.findIndex?.(item => ["R3582", "R3583"].includes(item?.id) || item?.name?.toUpperCase?.()?.includes?.("GIG")) > -1;
  const isMax500Plan = !isGigPlan && plans?.findIndex?.(item => ["R3582", "R3583"].includes(item?.id) || item?.name?.toUpperCase?.()?.includes?.("GIG")) == -1;
  const hasProfileInternet = (isGigPlan && ["R3582", "R3583"].includes(ecProfileCart?.ProfileDataProduct?.prodId)) || (isMax500Plan && ecProfileCart?.ProfileDataProduct?.prodName?.toUpperCase?.()?.includes?.("500 MBPS"))
    || (isGigPlan && ["R3582", "R3583"].includes(profileCart?.ProfileDataProduct?.prodId)) || (isMax500Plan && profileCart?.ProfileDataProduct?.prodName?.toUpperCase?.()?.includes?.("500 MBPS"));
  const hasProfilePerkCredit = profileCart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => (p?.name || p?.OfferText)?.toUpperCase?.()?.includes?.("HOME PERK CREDIT"))
    || ecProfileCart?.cartData?.[0]?.Promotions?.promotions?.find?.(p => (p?.name || p?.OfferText)?.toUpperCase?.()?.includes?.("HOME PERK CREDIT"));
  const productName = product?.productName || product?.name || product?.prodName;
  return serviceType?.toUpperCase?.() === Service.internet && isEmberMnHAuthenticated && !hasProfilePerkCredit && ((isGigPlan && productName?.toUpperCase?.()?.includes?.("GIG")) || (isMax500Plan && productName?.toUpperCase?.()?.includes?.("500 MBPS")))
    ? true
    : false;
}

export function getPerkGiftDts(source, product, serviceType, buildProduct, profileCart, ecProfileCart) {
  try {
    if (hasPerkGift(product, serviceType, buildProduct, profileCart, ecProfileCart)) {
      const productName = product?.productName || product?.name || product?.prodName;
      let perkGiftTitle = "Get a perk, on us";
      let perkGiftSubtitle = "Save up to $10/mo on an eligible perk like Disney+, Hulu, ESPN+ (With Ads) or Netflix & Max (With Ads).";
      let perkGiftHelperText = "Mobile + Home Perk Credit applied to active and eligible full price perk on either wireless or home service bill. 1 perk credit per account, credit will be applied in 1-2 billing cycles.";
      switch (source) {
        case "review":
          perkGiftSubtitle = `As a Mobile + Home customer, get up to $10/mo towards an eligible perk, like Disney+, Hulu, ESPN+ (With Ads) or Netflix & Max (With Ads), when you select and maintain a ${productName} plan.`;
          break;
        case "classic-savings":
          perkGiftSubtitle = "Save up to $10/mo on an eligible perk like Disney+, Hulu, ESPN+ (With Ads) or Netflix & Max (With Ads).";
          break;
        case "classic-review":
          perkGiftTitle = "Get an eligible perk, on us";
          // perkGiftSubtitle = `As a Mobile + Home customer, get up to $10/mo towards an eligible perk, like Netflix & Max (With Ads) or the Disney Bundle, when you select and maintain a ${productName} plan.`;
          perkGiftSubtitle =`As a Mobile + Home customer,get up to $10/mo credit towards an eligible perk,like Disney+, Hulu, ESPN+ (With Ads) or YouTube Premium when you select ${productName} combined with a Fios TV or Fios Digital Voice plan.`;
          perkGiftHelperText = `$10/mo credit applied to active eligible full price perk on either wireless or home service bill.`;
          break;
        case "classic-details":
          perkGiftTitle = "Get an eligible perk, on us.";
          perkGiftSubtitle = `As a Mobile + Home customer, get up to $10/mo towards an eligible perk, like Disney+, Hulu, ESPN+ (With Ads) or Netflix & Max (With Ads), when you select and maintain a ${productName} plan.`;
          perkGiftHelperText = `$10/mo credit applied to active and eligible full price perk on either wireless or home service bill. 1 perk credit per account, credit will be applied in 1-2 billing cycles.`;
          break;
        default:
          break;
      }
      let perkGift = {
        icon: "gift",
        title: perkGiftTitle,
        subtitle: perkGiftSubtitle,
        helperText: perkGiftHelperText,
      };
      return perkGift;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
}
